import {
  Activity,
  CalendarDays,
  CarFront,
  Check,
  FileText,
  Hash,
  House,
  KeyRound,
  Landmark,
  Shield,
  Tag,
  User,
} from "lucide-react";
import Icon from "./Icon";

// Maps the icon names used in permission data to lucide icons; unknown names
// (e.g. client-configured permissions) fall back to the mask-based Icon.
const lucideIcons = {
  checkmark: Check,
  policyNo: Hash,
  calendar: CalendarDays,
  profile: User,
  shield: Shield,
  document: FileText,
  price: Tag,
  house: House,
  key: KeyRound,
  wheel: CarFront,
  monitoring: Activity,
  bank: Landmark,
};

const Permission = ({ name, icon }) => {
  const LucideIcon = lucideIcons[icon];

  return (
    <li className="flex min-h-11 items-center gap-3 px-4 py-2.5 text-body-lg text-ink">
      {LucideIcon ? (
        <LucideIcon
          aria-hidden
          className="size-[18px] shrink-0 text-ink"
          strokeWidth={1.75}
        />
      ) : (
        <Icon name={icon} className="shrink-0" translate="" color="bg-ink" />
      )}
      {name}
    </li>
  );
};

export default Permission;
